import axios from '../axiosConfig';

const data = (p) => p.then(r => r.data);

export const projectApi = {
  list: (params) => data(axios.get('/projects', { params })),
  get: (id) => data(axios.get(`/projects/${id}`)),
  create: (body) => data(axios.post('/projects', body)),
  update: (id, body) => data(axios.patch(`/projects/${id}`, body)),
  remove: (id) => data(axios.delete(`/projects/${id}`)),
  addPlan: (id, items) => data(axios.post(`/projects/${id}/plan`, { items })),
  addItem: (id, body) => data(axios.post(`/projects/${id}/tasks`, body)),
  updateItem: (taskId, body) => data(axios.patch(`/project-tasks/${taskId}`, body)),
  toggle: (taskId) => data(axios.post(`/project-tasks/${taskId}/toggle`)),
  removeItem: (taskId) => data(axios.delete(`/project-tasks/${taskId}`)),
  restoreItem: (taskId) => data(axios.post(`/project-tasks/${taskId}/restore`)),
  reorder: (id, items) => data(axios.post(`/projects/${id}/reorder`, { items })),
  linkIncident: (taskId, incidentId) => data(axios.post(`/project-tasks/${taskId}/incident`, { incidentId })),
  unlinkIncident: (taskId) => data(axios.delete(`/project-tasks/${taskId}/incident`)),
  createIncident: (taskId, body) => data(axios.post(`/project-tasks/${taskId}/create-incident`, body)),
  addIncidentToProject: (incidentId, body) => data(axios.post(`/incidents/${incidentId}/add-to-project`, body)),
  activity: (id, params) => data(axios.get(`/projects/${id}/activity`, { params })),
  assignees: (projectId) => data(axios.get('/project-assignees', { params: { projectId } })),
  companies: () => data(axios.get('/companies')),
  categories: () => data(axios.get('/categories')),
  incidents: (params) => data(axios.get('/incidents', { params })),
};

/** Server error text for notifications. */
export const errorText = (err, fallback) => {
  const d = err && err.response && err.response.data;
  return typeof d === 'string' && d.length < 200 ? d : fallback;
};

export const PROJECT_STATUS = {
  planned: { label: 'Plánovaný', color: '#5abbff' },
  active: { label: 'Prebieha', color: '#00b96b' },
  on_hold: { label: 'Pozastavený', color: '#e88e39' },
  done: { label: 'Dokončený', color: '#798279' },
};

export const TASK_STATUS = {
  todo: { label: 'Nezačatá', color: '#8a8a8a' },
  in_progress: { label: 'Rozpracovaná', color: '#e88e39' },
  done: { label: 'Hotová', color: '#52c41a' },
  cancelled: { label: 'Zrušená', color: '#5c5c5c' },
};

export const PROJECT_COLORS = ['#00b96b', '#5abbff', '#a78bfa', '#e88e39', '#13c2c2', '#ff7aa2'];

export const ACTION_LABEL = {
  create: 'vytvoril(a)',
  update: 'zmenil(a)',
  complete: 'dokončil(a)',
  reopen: 'znovu otvoril(a)',
  delete: 'zmazal(a)',
  restore: 'obnovil(a)',
  link_incident: 'napojil(a) incident',
  unlink_incident: 'odpojil(a) incident',
  incident_sync: 'zmenil(a) incident →',
};

export const FIELD_LABEL = {
  title: 'názov',
  name: 'názov',
  description: 'popis',
  startDate: 'začiatok',
  endDate: 'koniec',
  targetDate: 'cieľový termín',
  status: 'stav',
  progress: 'percento',
  assigneeEmail: 'riešiteľa',
  assigneeName: 'riešiteľa',
  plannedEffort: 'plánovaný čas',
  actualEffort: 'skutočný čas',
  parentId: 'fázu',
  category: 'systém',
  color: 'farbu',
  ownerEmail: 'vlastníka',
  incident: 'incident',
};

export const todayYmd = () => {
  const d = new Date();
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};
